import { Brand, BACKEND_API } from '@trwl/backend.api'
import { createEffect, createEvent, createStore } from 'effector'
import { persist } from 'effector-storage/local'

export const $brands = createStore<Brand[]>([])

export const fetchBrandsFx = createEffect<void, Brand[], Error>(async () => {
  return BACKEND_API.BrandApi.getActiveBrands(500).then(({ data }) => data.filter((i) => i.name.trim().length > 0))
})

$brands.on(fetchBrandsFx.doneData, (_, brands) => brands)

export const loadBrands = createEvent()
loadBrands.watch(fetchBrandsFx)
persist({ store: $brands, key: 'brandList' })
